module.exports = __webpack_public_path__ + "img/ads3.0c122353.png";